export default "__VITE_ASSET__f_ArtEEU__"